module.exports = __webpack_public_path__ + "static/media/background_pc@2x.6deeda06.png";